(function () {
    "use strict";

    angular
        .module("app")
        .component("loginForm", {
            templateUrl: "src/app/login/loginForm.html",
            controller: controller,
            bindings: {
                ui: "<",
                onForgotPassword: "&",
                onContinue: "&",
                onCancel: "&"
            }
        });

    function controller(EMAIL_FORMAT) {
        const $ctrl = this;
        $ctrl.emailFormat = EMAIL_FORMAT;

        $ctrl.formData = {
            email: "",
            password: ""
        };
    }
    controller.$inject = ["EMAIL_FORMAT"];

})()